// HACK: patch window.fetch to include credentials
// this is necessary to use cross-origin (subdomain) session cookies
if (window?.fetch) {
  window._fetch = window.fetch
  window.fetch = (url, options, ...args) =>
    window._fetch(url, { ...options, ...{ credentials: 'include' } }, ...args)
}
